import { ComponentRendering, ImageField, NextImage } from '@sitecore-jss/sitecore-jss-nextjs';
import useHelpers from 'hooks/helpers';
import styles from 'components/Generic/Image.module.scss';

interface ImageProps {
  fields: {
    image: ImageField;
  };
  rendering: ComponentRendering;
}

const Image = ({ fields, rendering }: ImageProps): JSX.Element => {
  const { anchorId } = useHelpers(rendering);
  return (
    <div className={`${styles.image__wrapper} h-100`}>
      <NextImage id={anchorId} field={fields.image} fill />
    </div>
  );
};

export default Image;
